/**
* Use this file for JavaScript code that you want to run in the front-end
* on posts/pages that contain this block.
*
* When this file is defined as the value of the `viewScript` property
* in `block.json` it will be enqueued on the front end of the site.
*
* Example:
*
* ```js
* {
*   "viewScript": "file:./view.js"
* }
* ```
*
* If you're not making any changes to this file because your project doesn't need any
* JavaScript running in the front-end, then you should delete this file and remove
* the `viewScript` property from `block.json`.
*
* @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
*/
 
document.addEventListener('DOMContentLoaded', () => {
 
    // Splide
    const splides = document.querySelectorAll('.discover-slider');
    
    if (!!splides && splides.length > 0) {
      splides.forEach(splide => {
        const slides_count = splide.querySelectorAll('.splide__slide');
        // Grab the slide interval and convert it to an integer and milliseconds or fallback to 3000ms
        const interval = parseInt(splide.dataset.interval) * 1000 || 3000;
        const isAutoplay = splide.dataset.autoplay === "true";
        const isPauseOnHover = splide.dataset.pauseonhover === "true";
        const imagesPerSlideMob = parseInt(splide.dataset.imagesperslidemob);
        const imagesPerSlideTab = parseInt(splide.dataset.imagesperslidetab);
        const imagesPerSlideDesk = parseInt(splide.dataset.imagesperslidedesk);
        splide.setAttribute('role', 'region');
        splide.setAttribute('aria-label', 'Discover CPTS slider');
        const breakpoints = {
          // Mobile View (up to 640px)
          640: {
            perPage: imagesPerSlideMob,  // Show only one slide on screens below 640px
          },
          // Tablet View (between 640px and 1024px)
          1024: {
            perPage: imagesPerSlideTab,  // Show two slides on screens between 640px and 1024px
          },
          // Desktop View (above 1024px)
          2560: {  // "inf" represents infinity, targeting screens larger than 1024px
            perPage: imagesPerSlideDesk,  // Show three slides on desktops
          }
        };
  
        new Splide(splide, {
            classes: {
            }, type: slides_count.length > (imagesPerSlideDesk-1) ? 'loop' : 'slide', gap: '2rem', autoplay: isAutoplay, perPage: 3,perMove: 1, pauseOnHover: isPauseOnHover, interval: interval, breakpoints: breakpoints, i18n: {
                prev: 'Previous slide',
                next: 'Next slide',
                first: 'Go to first slide',
                last: 'Go to last slide',
                slideX: 'Go to slide %s',
                pageX: 'Go to page %s',
                play: 'Start autoplay',
                pause: 'Pause autoplay',
                carousel: 'Discover CPT Slider',
                select: 'Select a slide to show',
                slide: 'slide',
                slideLabel: '%s of %s'
            }
          }).mount();
          const slides = splide.querySelectorAll('.splide__slide');
      slides.forEach(slide => {
        slide.setAttribute('role', 'region');
      });
      const arrows = splide.querySelector('.splide__arrows');
      if (arrows) {
        arrows.setAttribute('role', 'group');
        arrows.setAttribute('aria-label', 'Discover CPT slider arrows');
      }
      })
  
    }
  
  });
 